import { Link } from "react-router-dom";

interface NewsLike {
  id: number;
  title: string;
  summary: string;
  category: string;
  date: string;
  image: string;
  views: number;
}

interface NewsCardProps {
  news: NewsLike;
  compact?: boolean;
}

export default function NewsCard({ news, compact = false }: NewsCardProps) {
  return (
    <Link
      to={`/news/${news.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div
        className={`w-full overflow-hidden bg-background-200 ${
          compact ? "h-40" : "h-48"
        }`}
      >
        <img
          src={news.image}
          alt={news.title}
          title={`${news.title} - 大岛优香资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2 text-xs text-foreground-500">
          <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-700 font-medium">
            {news.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center" />
            {news.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center" />
            {news.views}
          </span>
        </div>
        <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        {!compact && (
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {news.summary}
          </p>
        )}
      </div>
    </Link>
  );
}